import { useQuery } from "react-query";
import { publicRequest } from "utils";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { TSelectOption } from "global.types";

import {
  composeBranchesOptions,
  composeSpecialitiesOptions,
} from "../utils/doctorsFilters.utils";

interface useDoctorsFiltersReturns {
  specialities: TSelectOption[];
  branches: TSelectOption[];
}

export const useDoctorsFilters = (): useDoctorsFiltersReturns => {
  const { language } = useSelector((state: RootState) => state.global);

  const { data: specialitiesData } = useQuery([language, "specialties"], () =>
    publicRequest({
      url: `/api/specialties/${language}`,
      method: "get",
    })
  );

  const { data: branchesData } = useQuery(
    [language, "braches-filter-data"],
    () =>
      publicRequest({
        url: `/api/branches/${language}?type=clinic`,
        method: "get",
      })
  );
  
  return {
    specialities:
      composeSpecialitiesOptions(specialitiesData?.data?.data) || [],

    branches: composeBranchesOptions(branchesData?.data?.data) || [],
  };
};
